<template>
  <div class="t1">
    <nav_list></nav_list>
    <div class="t0tit">
      {{$lang(51055)}}
    </div>


    <div class="cont">
          <el-cascader class="ipt" v-model="city_id" :placeholder="this.$lang('37403')" :options="options"
            filterable @change="f5()"></el-cascader>

      <div class="list">
        <div class="itm" >

          <div class="points">
            <div class="pt1"  v-for="(pt, j) in citys" :key="j" @click="show_point(pt.id)" >
              {{pt.tit}}
            </div>
          </div>
        </div>
      </div>
    </div>

      <point_tc :id="0" ref="pot_tc"> </point_tc>
  </div>
</template>

<script>


import nav_list from '../index/nav_list.vue';
export default {
  name: "bus_list",

  components: {
    nav_list,
  },

  data() {
    return {
      city_id : 7,
      citys : [],
      options : [],
    };
  },
  mounted(e) {
    document.title = this.web_tit;
    this.f5()
  },

  methods: {
    show_point(id) {
      // alert(id)

      this.$refs.pot_tc.f5(id)
    },
    f5() {
      this.get("/index/point", { city_id: this.city_id, op: this.options.length },).then((e) => {
        if (this.options.length == 0) {
          this.options = e.select
        }

        this.citys = e.list
      });
    },

  }
}
</script>
<style scoped>

.ipt {
  width: 400px;
  margin-bottom: 40px;
}
.t0tit {
  margin: 30px auto;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  font-weight: bold;
}
.cont {
  width: 90vw;
  margin: 40px auto;
  text-align: center;

}
.tit {
  /* background-color: #2d3091; */
  color: #2d3091;
  width: 90%;
  margin: auto;
  margin-top: 14px;
}
.points {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
}

.points .pt1 {
  flex: 0 0 12%;
  margin-top: 4px;
  margin-left: 4px;
  background-color: #0464dd;
  color: #fff;
  font-size: 15px;
  height: 60px;
  line-height: 60px;
  /* border: 1px solid #f15a25; */
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}

.sybt {
  text-align: center;
  margin: 20upx;
  color: #000;
  font-size: 18px;
  position: relative;
  /*定位横线（当横线的父元素）*/
  display: block;
  /*设置为块级元素会独占一行形成上下居中的效果*/
}

.sybt::before,
.sybt::after {
  content: '';
  /*CSS伪类用法*/
  position: absolute;
  /*定位背景横线的位置*/
  top: 52%;
  background: #000;
  /*宽和高做出来的背景横线*/
  width: 40%;
  height: 1px;
}

.sybt::before {
  left: 0%;
  /*调整背景横线的左右距离*/
}

.sybt::after {
  right: 0%;
  /*调整背景横线的左右距离*/
}
</style>



// WEBPACK FOOTER //
// src/pages/index/points.vue